import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Row,
  Button,
  FormFeedback,
  Alert,
  Spinner,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

// Import your assets - adjust path as needed

import imageLogo from "../../../assets/orderingSystem/login-bg.jpg";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate, useParams, Link } from "react-router-dom";
import {
  registerCustomer,
  setEmailForOtp,
} from "../redux/slices/customerAuthSlice";
const arrow =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 50'%3E%3Cpath d='M10 25 Q50 5 80 25' stroke='white' fill='none' stroke-width='3' stroke-linecap='round'/%3E%3Cpolygon points='80,25 70,15 75,25 70,35' fill='white'/%3E%3C/svg%3E";

const CustomerRegister = () => {
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((s) => s.customerAuth || {});
  const { orgcode } = useParams();
  console.log("🚀 ~ CustomerLogin ~ orgcode:", orgcode);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNo: "",
      password: "",
      confirmPassword: "",
      isActive: true,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      email: Yup.string()
        .email("Please enter a valid email")
        .required("Email is required"),
      phoneNo: Yup.string()
        .matches(/^[0-9]{10,}$/, "Phone number must be at least 10 digits")
        .required("Phone number is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values) => {
      try {
        setErrorMsg(null);
        const res = await dispatch(registerCustomer(values));

        // Check if the action was fulfilled (Redux returns { type: 'customerAuth/register/fulfilled', payload: {...} })
        if (res?.type?.includes("fulfilled")) {
          // Store the email in Redux before navigating
          dispatch(setEmailForOtp(values.email));
          navigate(`/${orgcode}/verify-otp`);
        } else {
          // If rejected, res.payload contains the error
          const errorMsg =
            res?.payload?.message ||
            res?.payload ||
            "Registration failed. Please try again.";
          setErrorMsg(errorMsg);
        }
      } catch (err) {
        setErrorMsg("Registration failed. Please try again.");
        console.error("Registration failed:", err);
      }
    },
  });

  document.title = "Customer Register - Ordering System";

  return (
    <React.Fragment>
      <div className="vh-100">
        <Row className="h-100 g-0">
          {/* Register Form - Large screens */}
          <Col
            lg={{ size: 5, order: 2 }}
            md={{ size: 5, order: 2 }}
            xs={{ size: 12, order: 1 }}
            sm={{ size: 12, order: 1 }}
            xl={{ size: 6, order: 2 }}
            className="h-100 d-none d-sm-none d-md-block d-lg-block"
            style={{ backgroundColor: "#0f403b", overflowY: "auto" }}
          >
            <div className="py-5 d-flex flex-column justify-content-center align-items-center">
              <CardBody
                className="p-4"
                style={{ maxWidth: "450px", width: "100%" }}
              >
                <div className="text-center mb-lg-4 mb-1">
                  <h5 className="text-white">
                    Create your account to start ordering
                  </h5>
                </div>

                {errorMsg && (
                  <Alert color="danger">
                    {typeof errorMsg === "string"
                      ? errorMsg
                      : errorMsg?.message || JSON.stringify(errorMsg)}
                  </Alert>
                )}

                <div className="p-2 py-4">
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    <Row className="g-3">
                      {/* First Name */}
                      <Col xs={12} md={6}>
                        <Input
                          name="firstName"
                          className="form-control p-3"
                          placeholder="First Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.firstName || ""}
                          invalid={
                            validation.touched.firstName &&
                            validation.errors.firstName
                              ? true
                              : false
                          }
                        />
                        {validation.touched.firstName &&
                          validation.errors.firstName && (
                            <FormFeedback type="invalid">
                              {validation.errors.firstName}
                            </FormFeedback>
                          )}
                      </Col>

                      {/* Last Name */}
                      <Col xs={12} md={6}>
                        <Input
                          name="lastName"
                          className="form-control p-3"
                          placeholder="Last Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lastName || ""}
                          invalid={
                            validation.touched.lastName &&
                            validation.errors.lastName
                              ? true
                              : false
                          }
                        />
                        {validation.touched.lastName &&
                          validation.errors.lastName && (
                            <FormFeedback type="invalid">
                              {validation.errors.lastName}
                            </FormFeedback>
                          )}
                      </Col>

                      {/* Email */}
                      <Col xs={12}>
                        <Input
                          name="email"
                          className="form-control p-3"
                          placeholder="Email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email &&
                          validation.errors.email && (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          )}
                      </Col>

                      {/* Phone No */}
                      <Col xs={12} md={12}>
                        <Input
                          name="phoneNo"
                          className="form-control p-3"
                          placeholder="Phone No"
                          type="tel"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phoneNo || ""}
                          invalid={
                            validation.touched.phoneNo &&
                            validation.errors.phoneNo
                              ? true
                              : false
                          }
                        />
                        {validation.touched.phoneNo &&
                          validation.errors.phoneNo && (
                            <FormFeedback type="invalid">
                              {validation.errors.phoneNo}
                            </FormFeedback>
                          )}
                      </Col>

                      {/* Password */}
                      <Col xs={12} md={6}>
                        <div className="position-relative auth-pass-inputgroup">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={passwordShow ? "text" : "password"}
                            className="form-control pe-5 p-3"
                            placeholder="Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                            validation.errors.password && (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            )}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 pt-3 text-decoration-none text-muted"
                            type="button"
                            onClick={() => setPasswordShow(!passwordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </Col>

                      {/* Confirm Password */}
                      <Col xs={12} md={6}>
                        <div className="position-relative auth-pass-inputgroup">
                          <Input
                            name="confirmPassword"
                            value={validation.values.confirmPassword || ""}
                            type={confirmPasswordShow ? "text" : "password"}
                            className="form-control pe-5 p-3"
                            placeholder="Confirm Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.confirmPassword &&
                              validation.errors.confirmPassword
                                ? true
                                : false
                            }
                          />
                          {validation.touched.confirmPassword &&
                            validation.errors.confirmPassword && (
                              <FormFeedback type="invalid">
                                {validation.errors.confirmPassword}
                              </FormFeedback>
                            )}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 pt-3 text-decoration-none text-muted"
                            type="button"
                            onClick={() =>
                              setConfirmPasswordShow(!confirmPasswordShow)
                            }
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </Col>

                      {/* Register Button */}
                      <Col xs={12}>
                        <Button
                          disabled={loading}
                          color="success"
                          className="btn btn-success w-100"
                          type="button"
                          onClick={() => validation.handleSubmit()}
                        >
                          {loading ? (
                            <>
                              <Spinner size="sm" className="me-2" />
                              Registering...
                            </>
                          ) : (
                            "Register"
                          )}
                        </Button>
                      </Col>

                      {/* Sign In Link */}
                      <Col xs={12}>
                        <div className="text-center text-white mt-2">
                          Already have an account?{" "}
                          <Link
                            to={`/${orgcode}/customer-login`}
                            className="text-warning"
                            Sign
                            in
                          >
                            {" "}
                            Sign in
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </CardBody>

              <footer className="mt-auto w-100" style={{ marginTop: "40px" }}>
                <div className="container">
                  <Row>
                    <Col xs={12}>
                      <div className="text-center">
                        <p className="mb-0 text-muted">
                          &copy; {new Date().getFullYear()} Danfe Solution
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </footer>
            </div>
          </Col>

          {/* Register Form - Small screens */}
          <Col
            lg={{ size: 5, order: 2 }}
            xs={{ size: 12, order: 1 }}
            sm={{ size: 12, order: 1 }}
            xl={{ size: 6, order: 2 }}
            className="h-100 d-block d-sm-block d-md-none d-lg-none position-relative"
          >
            <img
              src={imageLogo}
              alt="Ordering System"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
              }}
            />
            <div
              className="py-5 d-flex flex-column justify-content-center align-items-center"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                overflowY: "auto",
              }}
            >
              <CardBody className="p-2 d-block justify-content-center align-content-center align-items-center w-100">
                <div className="text-center">
                  <h3
                    style={{ color: "white" }}
                    className="fw-bold mb-4 d-lg-none d-block"
                  >
                    Public Ordering System
                    <img src={arrow} alt="" className="w-25 ms-2" />
                  </h3>
                  <h6 className="text-light">
                    Create your account to start ordering
                  </h6>
                </div>

                {errorMsg && (
                  <Alert color="danger">
                    {typeof errorMsg === "string"
                      ? errorMsg
                      : errorMsg?.message || JSON.stringify(errorMsg)}
                  </Alert>
                )}

                <div className="p-2 py-3">
                  <div className="p-2 py-4">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                      }}
                    >
                      <Row className="g-3">
                        {/* First Name */}
                        <Col xs={6} md={6}>
                          <Input
                            name="firstName"
                            className="form-control p-3"
                            placeholder="First Name"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.firstName || ""}
                            invalid={
                              validation.touched.firstName &&
                              validation.errors.firstName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.firstName &&
                            validation.errors.firstName && (
                              <FormFeedback type="invalid">
                                {validation.errors.firstName}
                              </FormFeedback>
                            )}
                        </Col>

                        {/* Last Name */}
                        <Col xs={6} md={6}>
                          <Input
                            name="lastName"
                            className="form-control p-3"
                            placeholder="Last Name"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.lastName || ""}
                            invalid={
                              validation.touched.lastName &&
                              validation.errors.lastName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.lastName &&
                            validation.errors.lastName && (
                              <FormFeedback type="invalid">
                                {validation.errors.lastName}
                              </FormFeedback>
                            )}
                        </Col>

                        {/* Email */}
                        <Col xs={12}>
                          <Input
                            name="email"
                            className="form-control p-3"
                            placeholder="Email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email && (
                              <FormFeedback type="invalid">
                                {validation.errors.email}
                              </FormFeedback>
                            )}
                        </Col>

                        {/* Phone No */}
                        <Col xs={12} md={6}>
                          <Input
                            name="phoneNo"
                            className="form-control p-3"
                            placeholder="Phone No"
                            type="tel"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.phoneNo || ""}
                            invalid={
                              validation.touched.phoneNo &&
                              validation.errors.phoneNo
                            }
                          />
                          {validation.touched.phoneNo &&
                            validation.errors.phoneNo && (
                              <FormFeedback type="invalid">
                                {validation.errors.phoneNo}
                              </FormFeedback>
                            )}
                        </Col>

                        {/* Password */}
                        <Col xs={12} md={6}>
                          <div className="position-relative auth-pass-inputgroup">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control pe-5 p-3"
                              placeholder="Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                              }
                            />
                            {validation.touched.password &&
                              validation.errors.password && (
                                <FormFeedback type="invalid">
                                  {validation.errors.password}
                                </FormFeedback>
                              )}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 pt-3 text-decoration-none text-muted"
                              type="button"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </Col>

                        {/* Confirm Password */}
                        <Col xs={12} md={6}>
                          <div className="position-relative auth-pass-inputgroup">
                            <Input
                              name="confirmPassword"
                              value={validation.values.confirmPassword || ""}
                              type={confirmPasswordShow ? "text" : "password"}
                              className="form-control pe-5 p-3"
                              placeholder="Confirm Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.confirmPassword &&
                                validation.errors.confirmPassword
                              }
                            />
                            {validation.touched.confirmPassword &&
                              validation.errors.confirmPassword && (
                                <FormFeedback type="invalid">
                                  {validation.errors.confirmPassword}
                                </FormFeedback>
                              )}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 pt-3 text-decoration-none text-muted"
                              type="button"
                              onClick={() =>
                                setConfirmPasswordShow(!confirmPasswordShow)
                              }
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </Col>

                        {/* Register Button */}
                        <Col xs={12}>
                          <Button
                            disabled={loading}
                            color="success"
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                                Registering...
                              </>
                            ) : (
                              "Register"
                            )}
                          </Button>
                        </Col>

                        {/* Sign In Link */}
                        <Col xs={12}>
                          <div className="text-center text-white mt-2">
                            Already have an account?{" "}
                            <Link
                              to={`/${orgcode}/customer-login`}
                              className="text-warning"
                              Sign
                              in
                            >
                              {" "}
                              Sign in
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </CardBody>

              <footer className="mt-auto w-100">
                <div className="container">
                  <Row>
                    <Col xs={12}>
                      <div className="text-center">
                        <p className="mb-0 text-muted">
                          &copy; {new Date().getFullYear()} Danfe Solution
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </footer>
            </div>
          </Col>

          {/* Image Part - Desktop Only */}
          <Col
            lg={{ size: 7, order: 1 }}
            md={{ size: 7, order: 1 }}
            xl={{ size: 6, order: 1 }}
            xs={{ size: 12, order: 2 }}
            sm={{ size: 12, order: 2 }}
            className="position-relative h-100 d-none d-sm-none d-md-flex d-lg-flex"
          >
            {/* Background Image */}
            <img
              src={imageLogo}
              alt="Background"
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
            />

            {/* Overlay */}
            <div className="login-overlay d-flex flex-column justify-content-center align-items-start position-absolute w-100 h-100">
              <div className="overlay-content w-100 px-4">
                <h1 className="fw-bold display-5 mb-4 text-white d-flex align-items-center">
                  Public Ordering System
                  <img
                    src={arrow}
                    alt=""
                    className="ms-2"
                    style={{ height: "40px" }}
                  />
                </h1>
                <div>
                  <Card
                    className="p-4 border-0"
                    style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                  >
                    <h5 className="text-white mb-3">Why Join Us?</h5>
                    <ul className="list-unstyled text-white">
                      <li className="mb-2">
                        <i className="ri-check-line text-success me-2"></i>
                        Easy online ordering
                      </li>
                      {/* <li className="mb-2">
                        <i className="ri-check-line text-success me-2"></i>
                        Fast delivery
                      </li> */}
                      <li className="mb-2">
                        <i className="ri-check-line text-success me-2"></i>
                        Exclusive deals & discounts
                      </li>
                      {/* <li className="mb-2">
                        <i className="ri-check-line text-success me-2"></i>
                        24/7 customer support
                      </li>
                      <li className="mb-2">
                        <i className="ri-check-line text-success me-2"></i>
                        Safe & secure payments
                      </li> */}
                    </ul>
                  </Card>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <style>{`
        .login-overlay {
          top: 0;
          left: 0;
        }

        .auth-pass-inputgroup input {
          border-radius: 8px;
        }

        .form-control {
          border-radius: 8px;
          border: 1px solid #ddd;
        }

        .form-control:focus {
          border-color: #28a745;
          box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
        }

        .btn-success {
          background-color: #28a745;
          border-color: #28a745;
          border-radius: 8px;
          font-weight: 600;
        }

        .btn-success:hover {
          background-color: #218838;
          border-color: #218838;
        }

        .btn-success:disabled {
          background-color: #ccc;
          border-color: #ccc;
        }

        @media (max-width: 768px) {
          .vh-100 {
            min-height: 100vh;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default CustomerRegister;
